import { useEffect } from "react";
import { enableAutoPageviews } from "../helper/analytics";

/**
 * Hook to automatically track page views when routes change
 * Uses the original Plausible setup with auto pageviews
 * Use this in your main App component to enable automatic page tracking
 */
export const usePageTracking = (): void => {
  useEffect(() => {
    // Enable auto pageviews using the original Plausible setup
    enableAutoPageviews();
  }, []);
};
